import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
  CImg,
} from '@coreui/react'

const TheSidebar = (props) => {
  const dispatch = useDispatch()
  const show = useSelector((state) => state.sidebarShow)
  //logo_adda
  // console.log('props.navigation', props.navigation)
  return (
    <CSidebar
      show={show}
      onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}
      minimize={true}
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        <CImg
          src={require('../assets/img/praksa.png')}
          className="c-sidebar-brand-full"
          alt="Costing"
          height={50}
        />
        <CImg
          src={require('../assets/img/praksa_logo.png')}
          className="c-sidebar-brand-minimized"
          alt="Costing"
          height={30}
        />
      </CSidebarBrand>
      <CSidebarNav>
        <CCreateElement
          items={props.navigation}
          components={{
            CSidebarNavDivider,
            CSidebarNavDropdown,
            CSidebarNavItem,
            CSidebarNavTitle,
          }}
        />
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
